import { defineComponent as _defineComponent } from 'vue';
import { onBeforeUnmount } from 'vue';
import ScreenHead from '@blade-sxp/screen-new/components/screen-head/index.vue';
import ScreenMap from '@blade-sxp/screen-new/components/map/index.vue';
import { useMapStore } from '@blade-sxp/screen-new/store/map';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const store = useMapStore();
        // 初始化
        store.init();
        // 页面关闭-关闭ws
        onBeforeUnmount(() => {
            store.closeAllWebSockets();
        });
        // 更新快照时间
        const snapDateChange = (time) => {
            store.snapTime = time;
        };
        return { __sfc: true, store, snapDateChange, ScreenHead, ScreenMap };
    }
});
